export const segmentDevWriteKey = process.env.SEGMENT_DEV_WRITE_KEY;
export const segmentProdWriteKey = process.env.SEGMENT_PROD_WRITE_KEY;
